import { HttpResponse } from "@kgsport-cms/common";

export function awaitWrap<HttpResponse, U = any>(
  promise: Promise<HttpResponse>
): Promise<[U | null, HttpResponse | null]> {
  return promise
    .then<[null, HttpResponse]>((response: HttpResponse) => [null, response])
    .catch<[U, null]>(err => [err, null]);
}
